import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function MoreTestimonials() {
  const testimonials = ['Por primera vez sostuve una rutina.', 'Bajé de peso sin volverme loca.', 'Me siento otra persona.'];
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-180">
      <div className="text-center mb-10" data-id="element-181">
        <h2 className="font-display text-2xl md:text-3xl font-bold flex items-center justify-center gap-2 text-gray-900" data-id="element-182">
          <span className="text-brand-danger" data-id="element-183">❤️</span> MÁS MAMÁS QUE YA LO
          TIENEN
        </h2>
      </div>

      <div className="space-y-4" data-id="element-184">
        {testimonials.map((text, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-white/80 border border-pink-200 rounded-xl p-6 flex flex-col md:flex-row items-center gap-4 text-center md:text-left justify-center md:justify-start shadow-sm" data-id="element-185">
            <div className="flex gap-1 flex-shrink-0" data-id="element-186">
              {[...Array(5)].map((_, j) => <Star key={j} size={16} className="fill-brand-accent text-brand-accent" data-id="element-187" />)}
            </div>
            <p className="text-lg text-gray-600 font-medium italic" data-id="element-188">"{text}"</p>
          </motion.div>)}
      </div>
    </section>;
}